import React, { useState } from 'react'
import Handler from '../../../../Helpers/Handler'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { contentLoadingChange } from '../../../../Reducer/componentSlice'

const FinalVerify = ({ associateDetails, onVerified }) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    const renderStatus = (isValid) => (
        isValid ? <span className='badge bg-success'>Valid</span> : <span className='badge bg-danger'>Invalid</span>
    )

    const onSubmit = async () => {
        setLoading(true)
        dispatch(contentLoadingChange(true))
        const response = await Handler({ method: "patch", url: `/admin/client/associate/verify/${associateDetails?.associateId}` })
        dispatch(contentLoadingChange(false))
        if (response?.success) {
            toast.success(response?.data?.message || "Verified Successfully")
            setTimeout(() => { setLoading(false); onVerified?.() }, 1200)
        } else {
            setLoading(false)
            toast.error(response?.data?.message || "Cannot verify")
        }
    }

    const kyc = associateDetails?.kyc

    return (
        <>
            <table className='table'>
                <thead>
                    <tr>
                        <th>Type</th>
                        <th>Document No</th>
                        <th>Name</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {kyc?.aadhaar?.aadhaarNo && (
                        <tr>
                            <td>Aadhaar</td>
                            <td>{kyc.aadhaar.aadhaarNo}</td>
                            <td>{kyc?.aadhaar?.aadhaarDetails?.aadhaar_xml_data?.full_name || "-"}</td>
                            <td>{renderStatus(kyc?.aadhaar?.aadhaarDetails)}</td>
                        </tr>
                    )}
                    {kyc?.pan?.panNo && (
                        <tr>
                            <td>Pan</td>
                            <td>{kyc.pan.panNo}</td>
                            <td>{kyc?.pan?.panData?.name || "-"}</td>
                            <td>{renderStatus(kyc?.pan?.panData)}</td>
                        </tr>
                    )}
                </tbody>
            </table>

            <div className='d-flex justify-content-center mt-3'>
                <button className='btn btn-primary px-4' disabled={loading} onClick={onSubmit}>{loading ? "Verifying..." : "Verify"}</button>
            </div>
        </>
    )
}

export default FinalVerify
